import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import CustomerEditForm from './CustomerEditForm';
import CustomerList from './CustomerList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import CustomerListView from './CustomerListView'


export default function CustomerDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.dmpslice.customerDashboard);
  const [ customerId, setCustomerId] = React.useState('');
  const [reloadCustomerList, setReloadCustomerList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <CustomerEditForm 
            setReloadCustomerList={setReloadCustomerList}
            customerId={customerId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <CustomerListView 
                      setCustomerId = {setCustomerId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
